<ngx-one-column-layout>
    <nb-menu [items]="menu|async"></nb-menu>
    <router-outlet></router-outlet>
</ngx-one-column-layout>